import React from 'react';
import { motion } from 'framer-motion';
import Lottie from 'lottie-react';
import colorfulAnimation from 'assets/animations/dashboard-loading.json';
import grayAnimation from 'assets/animations/dashboard-loading-gray.json';

const Loader = ({
  loaderText,
  FullScreen = true,
  variant,
  message,
  subtitle,
  // Optional Tailwind size override for the Lottie box (e.g. "w-24 h-24") —
  // the inline default (w-12) letterboxes the wide three-dot animation.
  sizeClassName,
}) => {
  const resolvedVariant = variant ?? (FullScreen ? 'colorful' : 'gray');
  const text = message ?? loaderText ?? '';
  const hasText = Boolean(text);
  const isFullscreenColorful = FullScreen && resolvedVariant === 'colorful';

  if (resolvedVariant === 'button') {
    return (
      <span className="inline-flex items-center justify-center gap-2" role="status" aria-live="polite">
        <span
          aria-hidden="true"
          className="inline-block h-4 w-4 rounded-full border-2 border-current border-r-transparent animate-spin"
        />
        {hasText ? <span className="text-sm font-medium">{text}</span> : null}
      </span>
    );
  }

  const animationData = resolvedVariant === 'gray' ? grayAnimation : colorfulAnimation;
  const lottieSizeClass =
    sizeClassName ||
    (FullScreen
      ? resolvedVariant === 'colorful'
        ? 'w-56 h-56'
        : 'w-64 h-64'
      : hasText
        ? 'w-10 h-10'
        : 'w-12 h-12');
  const fullscreenLottieOffsetClass = isFullscreenColorful ? '-mt-10 -mb-10' : '';

  if (FullScreen) {
    return (
      <div className="min-h-screen w-full flex flex-col items-center justify-center bg-white">
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.25 }}
          className="flex flex-col items-center"
        >
          {resolvedVariant === 'colorful' ? (
            <div className="flex items-center gap-4">
              <img
                src="/fundmoreai.png"
                alt="Fundmore"
                className="h-12 w-auto"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
            </div>
          ) : null}

          <div className={`${lottieSizeClass} ${fullscreenLottieOffsetClass}`.trim()}>
            <Lottie
              animationData={animationData}
              loop={true}
              style={{ width: '100%', height: '100%' }}
            />
          </div>

          {hasText ? (
            <p className={`${isFullscreenColorful ? 'mt-0' : 'mt-2'} text-gray-600 font-medium`}>
              {text}
            </p>
          ) : null}
          {subtitle ? <p className="text-sm text-gray-400">{subtitle}</p> : null}
        </motion.div>
      </div>
    );
  }

  return (
    <div className="inline-flex items-center gap-2" role="status" aria-live="polite">
      <div className={lottieSizeClass}>
        <Lottie
          animationData={animationData}
          loop={true}
          style={{ width: '100%', height: '100%' }}
        />
      </div>
      {hasText ? <span className="text-sm font-medium text-gray-600">{text}</span> : null}
      {subtitle ? <span className="text-xs text-gray-400">{subtitle}</span> : null}
    </div>
  );
};

export default Loader;
